module.exports = __webpack_public_path__ + "img/SORIANA.d06e2121.png";